import { render, staticRenderFns } from "./Reset-password.vue?vue&type=template&id=1b19c654&scoped=true"
import script from "./Reset-password.vue?vue&type=script&lang=js"
export * from "./Reset-password.vue?vue&type=script&lang=js"
import style0 from "./Reset-password.vue?vue&type=style&index=0&id=1b19c654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b19c654",
  null
  
)

export default component.exports